<template>
  <BaseBlockingModal>
    <div class="delete-dish-modal">
      <h4>{{ $t('delete_dish.title') }}</h4>
      <div class="wrapper">
        <button class="btn green" @click="emitCancel">
          {{ $t('delete_dish.cancel') }}
        </button>
        <button class="btn red" @click="emitConfirm">
          {{ $t('delete_dish.confirm') }}
        </button>
      </div>
    </div>
  </BaseBlockingModal>
</template>

<script>
import BaseBlockingModal from "@/components/modals/BaseBlockingModal.vue";

export default {
  components: {
    BaseBlockingModal,
  },
  data() {
    return {};
  },
  methods: {
    emitConfirm() {
      this.$emit("confirm");
    },
    emitCancel() {
      this.$emit("cancel");
    },
  },
};
</script>

<style scoped>
.delete-dish-modal {
  text-align: center;
  display: flex;
  color: #ededed;
  flex-flow: row wrap;
  justify-content: space-around;
}
h4 {
  width: 100%;
  font-size: 2.7vh;
  line-height: normal;

  margin: 0;
}

.btn {
  width: 45%;
  border-radius: 5vh;
  padding: 1.5vh 0;
  text-align: center;
  font-size: 2vh;
  color: #ededed;
}

.wrapper {
  position: absolute;
  display: flex;
  justify-content: space-between;
  width: 85%;
  margin: 8vh auto 0;
  left: 0;
  right: 0;
}

.green {
  background: #129b81;
}

.red {
  background: #e2223b;
}
@media (min-width: 768px) {
  .wrapper {
    width: 23.264vw;
    margin: 4.167vw 0;
    display: flex;
    justify-content: space-between;
  }
  .btn {
    width: 10.903vw;
    height: 3.542vw;
  }
}
</style>
